
import React from 'react';

const MapSection: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Find Us</h2>
          <p className="text-lg text-gray-600">
            Located in the heart of Midrand for easy access from Johannesburg and Pretoria
          </p>
        </div>

        <div className="bg-gray-100 rounded-lg overflow-hidden shadow-lg">
          <iframe
            src="https://www.google.com/maps?q=No%206%20Riboville%20Road%2C%20183%20Randjesfontein%20Country%20Estate%2C%20Midrand&output=embed"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Sylman Academy Location"
          />
        </div>

        <div className="mt-8 bg-green-50 rounded-lg p-6">
          <div className="flex items-start space-x-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-map-pin-fill text-green-600 text-xl"></i>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Sylman Academy</h3>
              <p className="text-gray-700">
                No 6 Riboville Road<br />
                183 Randjesfontein Country Estate<br />
                Midrand<br />
                Gauteng, South Africa
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
